// Global error handler for chunk loading failures and auth recovery
// This prevents infinite loops when dynamic imports fail due to cache issues

let hasReloaded = false;

// Filter out common extension and development noise
const isExtensionError = (error: any): boolean => {
  if (!error || typeof error !== 'object') return false;
  const message = error.message || '';
  const stack = error.stack || '';
  
  return (
    message.includes('chrome-extension://') ||
    message.includes('moz-extension://') ||
    message.includes('safari-extension://') ||
    message.includes('Grammarly') ||
    message.includes('A listener indicated an asynchronous response') ||
    message.includes('Tracking Prevention blocked access') ||
    stack.includes('extension://')
  );
};

export const setupGlobalErrorHandler = () => {
  // Handle unhandled promise rejections (chunk loading failures)
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;
    
    // Filter out extension errors during development
    if (isExtensionError(error)) {
      event.preventDefault();
      return;
    }
    
    // Check if it's a chunk loading error
    if (error && typeof error === 'object' && 
        (error.message?.includes('Loading chunk') ||
         error.message?.includes('Loading CSS chunk') ||
         error.name === 'ChunkLoadError')) {
      
      console.warn('🔄 Chunk load error detected, initiating recovery');
      
      // Prevent multiple reloads
      if (!hasReloaded) {
        hasReloaded = true;
        
        // Clear relevant caches before reload
        if ('caches' in window) {
          caches.keys().then(names => {
            names.forEach(name => {
              if (name.includes('workbox') || name.includes('precache')) {
                caches.delete(name);
              }
            });
          });
        }
        
        // Reload after a short delay
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
      
      // Prevent the error from being logged to console
      event.preventDefault();
    }
  });

  // Handle script loading errors
  window.addEventListener('error', (event) => {
    // Filter out extension-related errors
    if (event.filename && (
      event.filename.includes('chrome-extension://') || 
      event.filename.includes('moz-extension://') ||
      event.filename.includes('safari-extension://')
    )) {
      return; // Ignore extension errors
    }
    
    if (event.target && 
        (event.target as any).tagName === 'SCRIPT' &&
        !hasReloaded) {
      
      console.warn('🔄 Script load error detected, initiating recovery');
      hasReloaded = true;
      
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  });
};

// Reset the reload flag on successful navigation
export const resetErrorHandler = () => {
  hasReloaded = false;
};